export * from '@nuxt-common/profile-management/config.mcom.js';
export * from '@nuxt-common/left-nav/config.mcom.js';
export * from '@nuxt-common/login-component/config.mcom.js';
export * from '@nuxt-common/credit-gateway/config.mcom.js';
export * from '@nuxt-common/create-account-component/config.mcom.js';
export * from '@nuxt-common/payment-cards/config.mcom.js';
export * from '@nuxt-common/account-verification-component/config.mcom.js';
export * from '@nuxt-common/creditcard-banner-consumable/config.mcom.js';

export const brand = 'mcom';
export const brandName = 'Macy’s';
export const onlineGuid = 'macys_online_guid';
export const onlineUid = 'macys_online_uid';

export const MY_ACCOUNT_FALL_BACK_ERROR = "We're sorry, but we cannot display your information at this time.";
export const DEFAULT_DISCOUNT = 30;
export const separateEntity = {
  SE_MATCH: () =>
    "We recently mailed a replacement Macy's Credit Card for each user of this account to the primary card holder. Your Wallet was automatically updated with your replacement card number.",
  SE_MISMATCH_MPAY: (preDuality) =>
    preDuality
      ? 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You\'ll need to add your replacement card to your Wallet and Macy\'s Pay. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>'
      : 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your Wallet and Macy\'s Pay as your old card is no longer valid. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>',
  SE_MISMATCH: (preDuality) =>
    preDuality
      ? 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You\'ll need to add your replacement card to your Wallet. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>'
      : 'We recently mailed a replacement Macy\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your Wallet as your old card is no longer valid. If the primary card holder did not receive your replacement card, they can call 855-926-1647 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>',
};
export const giftCardImageUrl = (productImageUrl) =>
  `https://slimages.${window.location.hostname.replace('www.', '')}/is/image/MCY/products/${productImageUrl}.tif`;
export const OFFERPROMOS = {
  title: 'Promos & Offers',
  viewAllText: 'View all',
  viewAllUrl: '/shop/coupons-deals?linklocation=pagecontent',
  linkStyle: 'secondary-cta',
  serviceInterruption: 'Service Interruption',
  promoColor: 'primary-color',
  promoCode: 'Promo Code',
  noPromoCode: 'No Promo Code',
  shopNow: 'Shop Now',
  exclusionDetails: 'Exclusion & Details',
  exclusionDetailsSlideoutTitle: 'Exclusion & Details',
  offerErrorPrimaryText: 'Discover our latest deals',
  viewOffers: 'View offers',
  offerErrorLink: '/shop/coupons-deals?cm_sp=macys_account-_-my_wallet-_-deals_and_promotions',
  tag: {
    event_name: 'my account overlay',
    link_name: 'exclusion and details',
  },
};
export const CREDIT_CARD = {
  heading: 'Macy’s Credit Card',
  maintenanceAlertTitle: 'Maintenance Alert',
  serviceInterruptionTitle: 'Service Interruption',
  importantNotice:
    "Because you have added your Macy’s Credit Card to this section of the macys.com website, information about your Macy’s Credit Card, such as account balance, available credit and bank account information, is visible on macys.com as well as on the credit card issuer's website. Anyone who has or gains access to your macys.com sign-in will have access to your financial information displayed here. You should not give access to your macys.com sign-in to anyone you would not want to have access to your financial information. If you have concerns about anyone with access to your Macy’s sign-in seeing your information, you should change the password associated with your Macy’s sign-in, or contact customer service at 1-888-257-6757 to discuss additional options.",
  errorMessage: "We're sorry, but we cannot display your Macy's Credit Card information at this time.",
  gatewayLink: (index, query = '') => `/my-credit/gateway/cards/${index}?linklocation=pagecontent${query}`,
  emptyCard: {
    propsCardImage: 'macysprops.png',
    title: 'Macy’s Credit Card',
    description: 'To manage your Macy’s Credit Card or make a payment, just add your card here.',
    addTagLink: 'add your Macy’s card',
    addCardLabel: 'Add Your Macy’s Card',
    openCardOffer: {
      title: (discount) => `Open a Macy’s Card<sup>*</sup> & get ${discount}% off`,
      description: 'Today on macys.com purchases. Discount in store varies. Save up to a total of $100.',
      learnUrl:
        '/p/credit-service/learn-and-apply/?cm_sp=macys_account-_-macys_credit_card-_-apply_and_learn&acquisitionOrigin=MyaccountLnApplynow&linklocation=pagecontent',
      learnLabel: 'Learn & Apply',
      subjectToApprovalLabel: 'Subject to credit approval.',
      exclusionsUrl: '/p/new-accounts?linklocation=pagecontent',
      exclusionsLabel: () => 'Exclusions & Details',
    },
  },
  paymentCard: {
    endingIn: 'Ending in:',
    minimumPayment: 'Minimum Payment:',
    dueDate: 'Due Date:',
    nextAutoPayment: 'Next Autopayment:',
    currentBalance: 'Current Balance:',
    availableCredit: 'Available Credit:',
    makeAPaymentLabel: 'Make A Payment',
    importantNoticeLabel: 'Important Notice',
    viewDetailsLabel: 'View Details',
    tag: {
      selectedCardPersistentLogin: {
        page_type: 'step up login',
        page_name: 'home credit card view details',
        event_name: 'credit card view details',
        link_name: "view macy's card details",
      },
      selectedCard: {
        event_name: 'my account overlay',
        link_name: "view Macy's card details",
      },
      legalNotice: {
        event_name: 'my account overlay',
        link_name: 'important notice',
      },
      maintenanceAlert: {
        event_name: 'my account overlay',
        link_name: 'maintenance alert',
      },
      makePaymentView: {
        page_type: 'step up login',
        page_name: 'home credit card make a payment',
        link_name: 'make a payment',
      },
      makePaymentLink: {
        link_name: 'make a payment',
        event_name: 'make a payment',
      },
    },
  },
  cardSlideout: {
    currentBalance: 'Current balance',
    defaultCard: 'Default card',
    propCardTitle: 'Macy’s Credit Card',
    inStorePurchases: 'In-Store Purchases',
    amexCardTitle: 'Macy’s American Express® Card',
    outsidePurchases: 'Outside Purchases',
  },
  dualLineSummary: {
    minimumPayment: 'Minimum payment',
    dueDate: 'Due date',
    availableCredit: 'Available credit',
    importantNotice: 'Important notice',
    importantNoticeLabel: 'Important Notice',
    viewDetails: 'View Details',
    makeAPayment: 'Make A Payment',
    nextAutoPayment: 'Next Autopayment',
    currentBalance: 'Current Balance',
    creditSummary: 'Credit summary',
  },
  attentionOverlay: {
    message: "There's no need to make a payment this time because you have a zero balance.",
    okLabel: 'OK',
  },
  amexOffers: {
    heading: 'Amex Offers',
    simplyActivateLink: 'Simply activate offers',
    simplyActivateMessage: ', then pay with your Card to receive a statement credit, ',
    simplyActivateTerms: 'terms apply',
    activateOffersMessage:
      'Activate offers, pay by card, get statement credits! By clicking offers, you agree to let Macy’s share your card number with Amex.',
    termsLabel: 'Terms',
    offersLabel: 'Offers',
    termsAndConditionsTitle: 'Terms & Conditions',
  },
  amexTerms: {
    informationSharing: {
      header: 'INFORMATION SHARING',
      body: {
        part1: 'When you click ',
        part2:
          ', your Macy’s American Express card number will be shared with American Express. American Express will retain your card number. In the event you activate an offer, American Express will use your card number to fulfill activated offers if you make the required purchase(s).',
      },
      offerTextWithConsent: '"Simply activate offers"',
      offerTextWithoutConsent: '"Offers"',
    },
    offerActivation: {
      header: 'OFFER ACTIVATION',
      body: {
        part1: 'All available offers will be shown by clicking on ',
        part2:
          '. To earn a statement credit, activate the offer and spend the amount specified in the offer at the specified merchant on your Macy’s American Express Card prior to the offer expiration date.',
      },
      offerTextWithConsent: '"Simply activate offers"',
      offerTextWithoutConsent: '"Offers"',
    },
    statementCredit: {
      header: 'STATEMENT CREDIT ISSUANCE',
      body: 'Statement Credits will appear on your statement within ninety (90) days following the end of the applicable offer period. Statement Credits may be reversed if a qualifying transaction is returned/cancelled.',
    },
    disclaimer:
      'American Express Travel Related Services Company Inc. is solely responsible for these offers, and is not affiliated with Macy’s, Citibank, N.A. or their affiliates.',
    programTerms: {
      label: 'Amex Program Terms',
      url: 'http://www.amexoffers.com/partnerterms',
    },
  },
};
export const WALLET = {
  heading: 'Wallet',
  menuLabel: 'Wallet',
  addCardLabel: 'Add a card',
  serviceInterruptionLabel: 'Service Interruption',
  cardSaveSuccess: 'Changes saved to your wallet.',
  editLabel: 'Edit',
  defaultLabel: 'Default',
  defaultCardLabel: 'Default Card',
  removeLabel: 'Remove',
  cardLimit: 10,
  addCreditCardTitle: 'Add Credit Card',
  editCreditCardTitle: 'Edit Credit Card',
  deleteConfirmMessage: 'Are you sure you want to delete this card',
  setAsDefaultLabel: 'Set as default',
  emptyWallet: {
    description: 'Your Wallet is empty',
    subDescription: 'Securely store a payment method for faster checkout.',
    addPaymentLabel: 'Add payment method',
  },
  cardImages: {
    Y: {
      image: 'macysprop.png',
      altText: 'Macy’s Prop Card',
    },
    B: {
      image: 'macysamex.png',
      altText: 'Macy’s American Express Card',
    },
    M: {
      image: 'mastercard_logo.png',
      altText: 'MasterCard',
    },
    V: {
      image: 'visa_logo.png',
      altText: 'Visa',
    },
    O: {
      image: 'discover_logo.jpg',
      altText: 'Discover',
    },
    A: {
      image: 'amex_logo.png',
      altText: 'American Express',
    },
    F: {
      image: 'macysprop.png',
      altText: 'Macy’s Prop Card',
    },
  },
  paymentCardSlideout: {
    cardNames: ['macysprop', 'macysamex', 'Macy’s American Express', 'Macy’s', 'employeeCard'],
  },
  tag: {
    defaultErrorCode: '999',
    defaultErrorLabel: ['api response error'],
    error: {
      event_name: 'My account error',
      error_category: 'my account',
      error_misc: [''],
    },
    addCard: {
      event_name: 'add a card',
      link_name: 'edit account',
      site_action: 'add card start',
    },
    editCard: {
      event_name: 'edit a card',
      link_name: 'edit a card',
    },
    deleteCardStart: {
      site_action: 'delete card start',
      action_location: 'my account:home',
      event_name: 'edit account',
      link_name: 'edit account',
    },
    deleteCardComplete: {
      site_action: 'delete card complete',
      action_location: 'my account:home',
      event_name: 'edit account',
      link_name: 'edit account',
    },
  },
};
export const PURCHASE_HISTORY = {
  purchaseHistoryLabel: 'Purchase History',
  noPurchasesAvailable: "You haven't made any purchases yet",
  noPurchasesAvailableSubHeading: "Once you do, they'll live here.",
  startShopping: 'Shop Now',
};
export const WISHLIST = {
  listText: 'Lists',
  viewAllText: 'View all',
  goToText: 'Go to',
  redirectionUrl: '/wishlist/home?linklocation=pagecontent',
  createListLabel: 'Nothing on your list—yet',
  manageListText: 'Create a list',
};
export const LOYALTY = {
  salutation: (firstName) => `Hi, ${firstName}`,
  pointDetails: () => 'Points add up to rewards — earn on every purchase',
  dashboardLink: '/loyalty/starrewards?cm_sp=macys_account-_-starrewards-_-star_rewards&lid=star_rewards-star_rewards&linklocation=pagecontent',
  dashboardText: 'View my dashboard',
  noLoyaltyText: "Pay any way you like & earn on Macy's purchases, get free shipping over $39, plus free returns.",
  defaultMaxPointsThreshold: 1000,
  rewards: '1000 points = $10 Star Money',
  joinNowLink: '/loyalty/starrewards?lid=star_rewards-star_rewards&linklocation=pagecontent',
  defaultTrackerTierName: '',
};
export const INBOX = {
  rewardsLabel: 'Star Rewards',
  viewButtonLabel: ' VIEW DETAILS',
  ordersLabel: 'Orders',
  noNewMessageText: 'You have no new messages.',
  creditCards: {
    heading: 'Macy’s Credit Card',
    walletUrl: '/account/wallet?ocwallet=true',
    manageCardText: (cardNumber) => `Download statements, make payments and manage your Macy’s Card ending in ${cardNumber} online.`,
    addCardAriaLabel: 'add your macy’s card button',
    addCardButtonLabel: 'ADD YOUR MACY’S CARD',
    setDefaultCardText: 'Set your Macy’s Card as your default card to earn Star Rewards for your purchases.',
    setAsDefaultAriaLabel: 'set as default button',
    setAsDefaultButtonLabel: 'SET AS DEFAULT',
  },
  addCardToWallet: {
    walletLabel: 'Wallet',
    saveCreditCard: 'Checkout in just a few clicks by securely saving a credit card in your Wallet.',
    addCardLabel: 'ADD A CREDIT CARD',
    saveChangesToWallet: 'Changes saved to your wallet.',
    addCardSlideoutId: 'add-SlideOut',
  },
  enrollRewards: {
    signUpForStarRewards: "It's free! Sign up for Star Rewards to earn rewards when you shop at Macy’s.",
    enrollTodayLabel: 'ENROLL TODAY',
    rewardsPageUrl: '/loyalty/starrewards',
  },
  rewardCards: {
    congratsText: 'Congrats!',
    rewardsEarned: "You've earned",
    redeemText: 'in Star Money.',
    viewButtonLabel: 'view details button',
  },
};
export const MESSAGES = {
  userCreationMessage: 'Success! You created a Macy’s online account. Your existing Star Rewards membership has been linked.',
  successfulUserCreationWithRewards: 'Congrats! You created a Macy’s account & added your Star Rewards membership.',
  viewBenefits: 'View your benefits',
  congratsText: 'Congrats,',
  successfulUserCreation: "You've successfully created a Macy’s account.",
  addRewardsLinkRedirectionURL: '/loyalty/starrewards?cm_sp=macys_account-_-star_rewards-_-add_your_star_rewards_memebership_view_benefits_here',
};
export const DASHBOARD = {
  tag: {
    defaultErrorCode: '999',
    defaultErrorLabel: ['api response error'],
    error: {
      event_name: 'My account error',
      error_category: 'my account',
      error_misc: [''],
    },
  },
};

export const GIFT_CARD_BALANCE = {
  checkBalance: 'Check your gift card balance',
  usingGiftCard: '',
  imageAltText:
    'Your gift card number is the first set of 16-18 digits that appear under the barcode on your e-gift card or on the back of your physical gift card.',
  cidImageAltText:
    'Your CID number is the last set of 3 or 4 digits that appear under the barcode on your e-gift card or on the back of your physical gift card.',
  egiftCardLabel: 'E-Gift Card',
  cardText: 'Your card number is located in the email we sent you.',
  giftCardLabel: 'Gift Card',
  cidText: 'Your CID number is located in the email we sent you.',
  termsAndConditions: `For balance inquiry, call 1-800-511-2752 or go to macys.com/gcbal. This card is
      redeemable only for merchandise and in-store services at Macy’s, Macy’s Backstage,
      Market by Macy’s and macys.com (US only); it may not be redeemed for cash (except
      as required by law) or applied as payment or credit to any credit card account.
      Macy’s reserves the right to decline gift cards from unauthorized sellers,
      including auction sites. This card may be placed on hold or rejected if fraud is
      suspected. Protect this card: you are responsible if it is lost or stolen. Lost or
      stolen cards will only be replaced with proof of purchase and only for the value
      shown on our records. This card is issued by Macy’s Retail Holdings, LLC and is
      required for all inquiries. Your Macy’s gift card never expires.<br>
      Never share a gift card number or 4 digit security code with someone you don’t know.`,
};

export const NEED_HELP = {
  needHelpText: 'Need help?',
  phoneNumber: '1-800-289-6229',
  callText: 'Call',
};
